var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLightOnIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0005 21H10.0005V19.5H14.0005V21ZM11.98 7C14.46 7 16.48 9.02 16.48 11.5C16.51 12.8398 15.9504 13.8398 15.4604 14.7197C15.0004 15.5497 14.6001 16.26 14.6001 17.25V18H9.36963V17.25C9.36963 16.27 8.97025 15.5497 8.51025 14.7197C8.02027 13.8398 7.46975 12.8399 7.48975 11.5C7.48975 11.38 7.49049 11.2596 7.50049 11.1396C7.62061 9.60981 8.5204 8.28025 9.80029 7.57031C10.4503 7.21034 11.19 7.00001 11.98 7ZM12.0005 8.49023C10.3505 8.49023 9.00049 9.84023 9.00049 11.4902C8.98055 12.4501 9.36963 13.1605 9.82959 13.9805C10.2296 14.6904 10.6698 15.4803 10.8198 16.4902V16.5H13.1802C13.3302 15.5 13.7704 14.7102 14.1704 13.9902C14.6304 13.1702 15.0205 12.4598 15.0005 11.5098C15.0004 9.84003 13.6602 8.49048 12.0005 8.49023ZM8.28662 6.72656L7.22607 7.78711L5.45752 6.02051L6.51807 4.95898L8.28662 6.72656ZM18.5415 6.01758L16.7739 7.78613L15.7134 6.72559L17.481 4.95703L18.5415 6.01758ZM12.7505 5.5H11.2505V3H12.7505V5.5Z",
    fill: "#161616"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLightOnIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Light_On_Icon.ac9f6bc8e57877d923bfd1f9899b5f1a.svg";